import { get } from 'lodash'
import { registerAllEditors } from '@components/editors/index.js'
import { registerAllRenderers } from '@components/renderers/index.js'
import DefaultFieldTypeMap from '@constants/default_field_type_map.js'

export { registerAllEditors, registerAllRenderers }

export function registerAllModules() {
  registerAllEditors()
  registerAllRenderers()
}

// helper function to get component from a map of component types to components
export const getComponentTypeMapping = (fieldType, fieldTypeMap = DefaultFieldTypeMap) => {
  // Now get the correct component from registry by mapping field.variant_type to a component renderer/editor
  return get(fieldTypeMap, [fieldType]) || 'string' // default to string if we can't find correct mapping
}

/*

// Example usage

import { registerAllModules } from './registry'

registerAllModules()

import { getRenderer } from './components/renderers/registry'
import { getEditor } from './components/editors/registry'


const editable = false

const NumericComponent = editable ? getEditor('numeric') : getRenderer('numeric')
const StringComponent = editable ? getEditor('string') : getRenderer('string')
const root = createRoot(document.getElementById('react-target'))
root.render(
  <Provider store={store}>
    <NumericComponent value={"Dynamic number value passed as value prop"} />
    <StringComponent value={"Dynamic string value passed as value prop"} />
  </Provider>
)
*/
